export class WorkflowDefinitionsPaginate {
  totalCount: number;
  totalPages: number;
  pageNumber: number;
  pageSize: number;
  items: WorkflowDefinitions[];
}

export class WorkflowDefinitions {
  definitionId: string;
  bacSourceId: number;
  startStepGuid: string;
  name: string;
  description: string;
  versionId: string;
  version: number;
  isSingleton: boolean;
  isLatest: boolean;
  isPublished: boolean;
}

export class WorkflowDefinitionsVersion extends WorkflowDefinitions {
  variables: WorkflowDefinitionsVersionVariables[];
  steps: WorkflowDefinitionsVersionSteps[];
}

export class WorkflowDefinitionsVersionVariables {
  guid: string;
  type: WorkflowType;
  conditionCode: WorkflowConditionCode;
  condition: string;
  name: string;
  description: string;
  value: WorkflowDefinitionsVersionVariablesValue;
  properties: WorkflowDefinitionsVersionVariablesProperties[];
}

export enum WorkflowType {
  BacVirtualEntreeSortie = 'BacVirtualEntreeSortie',
  CourrierStatut = 'CourrierStatut',
}

export enum WorkflowConditionCode {
  Optional = 'Optional',
  Required = 'Required',
  System = 'System',
}

export class WorkflowDefinitionsVersionVariablesValue {
  sourceType: WorkflowVersionVariablesValueData;
  data: string;
}

export enum WorkflowVersionVariablesValueData {
  FreeText = 'FreeText',
  Database = 'Database',
  Courrier = 'Courrier',
  ContextVariable = 'ContextVariable',
}

export class WorkflowDefinitionsVersionVariablesProperties {
  name: string;
  value: string;
}

export class WorkflowDefinitionsVersionSteps {
  type: WorkflowDefinitionsVersionStepsType;
  bacId?: number;
  guid: string;
  name: string;
  description?: string;
  displayOrder?: number;
  text?: string;
  okStepGuid?: string;
  properties?: WorkflowDefinitionsVersionVariablesProperties[];
}

export enum WorkflowDefinitionsVersionStepsType {
  Question = 'Question',
  Signature = 'Signature',
  Routing = 'Routing',
  ModifyData = 'ModifyData',
}
